import { render } from "./UserGrid.vue?vue&type=template&id=aeca1b66"
import script from "./UserGrid.vue?vue&type=script&lang=js"
export * from "./UserGrid.vue?vue&type=script&lang=js"

import "./UserGrid.vue?vue&type=style&index=0&id=aeca1b66&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__